seedWebApp.controller('SalesRepsController', ['$scope', '$rootScope', 'ContactService', '$uibModal', 'ToastService', 'TranslationService',
    function ($scope, $rootScope, ContactService, $uibModal, ToastService, TranslationService) {

    $scope.translation = TranslationService.getActiveTranslation();
    $scope.prefs = {
        name: 'SalesRepsGrid',
        sortByCol: null,
        canAdd: false,
        canEdit: true,
        canDelete: false,
    };


    $scope.columns = [
        { name: 'SalesRepID', display: 'ID', orderBy: 'asc', editable: false, width: 5, isKey: true },  //filterOptions: [] 
        { name: 'SalesRepName', display: 'Nome', editable: true, width: 15 },
        { name: 'PersonName', display: 'Representante', editable: true, width: 10 },
        { name: 'CountryID', display: 'Pais', editable: true, width: 5 },
        { name: 'PlantID', display: 'Planta', editable: true, width: 5 },
        //{ name: 'IsActive', display: 'Ativo', editable: true, width: 5, dataType: 'boolean' },
        { name: 'IsActive', display: 'Ativo', dataType: 'boolean', filterOptions: [], width: 5 },
    ];


    $scope.prefs.sortByCol = $scope.columns[0];
    $scope.prefs.sortByCol.orderReverse = false;

    $scope.loadService = ContactService.getSalesReps;
    $scope.resetService = ContactService.resetCache;
    //$scope.loadColumns = ContactService.getContactsColumns;

    $scope.getTotal = function () {
        $scope.loadingTotal = true;
        ContactService.getSalesRepsCount().then(function (response) {
            $scope.loadingTotal = false;
            if (response) {
                $scope.totalItems = response.data.TotalCount;
                //$scope.lastSync = response.data.LastSync;
            }

        });
    };

    $scope.getTotal();

    $scope.searchMode = function () {
        $scope.$broadcast('inputSearch', $scope.filterString);
    };

    $scope.doRefresh = function () {
        $scope.$broadcast('refreshServiceGrid');
    };

    $scope.toExcel = function () {
        $scope.$broadcast('toExcel', 'representantes');
    };

    $scope.doInsert = function () {
        $scope.$broadcast('addItem');
    };

    //$(document).ready(function () {
    //    $scope.overflowSize = $scope.AdjustSize();
    //});

}]);
